import { useMsal } from 'src/auth/firebaseMsalCompat';
import { useEffect } from 'react';
import { trackPageView } from '../services/telemetry';

export function Logout() {
  const { instance } = useMsal();

  useEffect(() => {
    document.title = 'Logout - PineappleMusicLab';
    trackPageView('Logout', '/logout');
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
    });
  }, [instance]);

  return <div>Logout</div>;
}
